// Calls and evals use the static outbound token, so a Cognito user lands on
// the agents area after signing in.
export const defaultAuthenticatedPath = '/agents';

export const oauthRedirectPath = '/redirecting';

export const postSignInRedirectStorageKey = 'voice-agent:post-sign-in-redirect';
